// export const environment = {
//   version: '1.2.2',
//   production: true,
//   environment: 'production',
//   apiURL: 'https://api-preprod-v2.worldofsweets.co.uk/',
//   apiVersion: 'v1',
//   username: 'appuser@mailinator.com',
//   password: 'Admin@123456',
//   client_id: 'Qp3IFurNh9hKL9WcwSPTpDaKce1p6bwXrFGvFpjG',
//   s3_path: 'https://d34j3twnxbfb5r.cloudfront.net',
//   product_image_folder:'thumbnails',
//   client_secret: 'bZ3s1CEFYweEaLXiy9CIU7nFYkRwodeLfQ2o5JwqD4DeeL4nwRnbcKahwJhHW4aRGdaiVrHhmbOnrcV2iWPgrwbOA1oamAjlQZ6DFHnVsJRedLR4vkFh9BNckCkQVFeD',
//   grant_type: 'password',
//   page_size: 10,
//   profileFolder:'ordering/profile-images/',
//   product_listing_page_size: 15,
//   cart_page_size: 20,
//   cmsNavigationUrl:'https://retailers-preprod-v2.worldofsweets.co.uk',
//   graphcmsapiurl:'https://api-eu-central-1.graphcms.com/v2/cknrki1wfbcpo01wj1hxy2dmz/stagenvironment',
//   qraphapiToken:'eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCIsImtpZCI6ImdjbXMtbWFpbi1wcm9kdWN0aW9uIn0.eyJ2ZXJzaW9uIjozLCJpYXQiOjE2MTk2OTExNDAsImF1ZCI6WyJodHRwczovL2FwaS1ldS1jZW50cmFsLTEuZ3JhcGhjbXMuY29tL3YyL2NrbnJraTF3ZmJjcG8wMXdqMWh4eTJkbXovc3RhZ2Vudmlyb25tZW50IiwiaHR0cHM6Ly9tYW5hZ2VtZW50LW5leHQuZ3JhcGhjbXMuY29tIl0sImlzcyI6Imh0dHBzOi8vbWFuYWdlbWVudC5ncmFwaGNtcy5jb20vIiwic3ViIjoiNDc3MjQ2NjctMGRiMC00ZmY0LTg0MTgtMzMwNzc4MTE0NzkxIiwianRpIjoiY2tvMnFhYW5mejZ3djAxejEzeGhnYXBlaSJ9.KpjmM-f3feMhNZc2Mi40gpiO-wK4Po68cbNpJLn9oHmUmMacnK7BMjwNOeT79F4naQxkjveJ03JNLueKD8XAFC72WkRCMc4yd9HZbiA2XkAEsCPmuDdnoOGLNqnTZUVRM6qwizuJ3AuhWubXSwJhiWXVApkSsND0WXp6lfVvm8p_xjnDMst2PGcVFW7j8EPCR_bJpCtzwsTTr2wIUDrH35FhonMnjvhfTMbCUqYy3C16CAFH3xmYkjZ3Xso4Ag-2sLYh9-I_FX0YNmKgQofMhy1qYoPSVozzymYMaDC8b5YfGNqQ2vzeYwWwnamMW71rIfoYdAtQ61en8w82_mm5svqJUZdhZmo5So6bnJghg7x_FWN_s4HNPanlpATaipKE0wI_bkRIRNllVczwNIO43WUWjTA_2QUOx3_FTQIYbeQZHPcdjV44x9q9gVvr3rBsf6MBqK5XmckT35311Hrw5Do0UuzprqTTulkURNQQXbXjiPjoAGrsz1YUgs_gHVZGd7vqr0LebX77Tzvvlz_TgHmoDnu_nLZuBjwiwKO_ruMvPY_Bf-K85HNzFQKpeOZ-ldkdsEjp1g0eAaVcXflbHdKliT6O11co8BZsHwSuie0SLpz9iKIclMQHslug8qAmvtWJ8P-Z5MImolh7b2K2xtGv3eW9r6_8Y6fmoNBj9a4',
//   domainName:'web-shb-bonds-stg.agilecollab.com',
//   ga:'G-G1Y6E62JXB',
//   // checkoutToken:"pk_sbox_emqjo5cursanbqvmpbdqv4n224j",
//   wos_secret_key:'password@123',
//   versionCheckURL:'https://retailers-preprod-v2.worldofsweets.co.uk/version.json',
//   hashedSecretKey:'f38ecf5379324f565d0365be0547b42e',
//   hashedIV:'186DE986FC69F8E4',
//   recaptchaSecretKey:'6LdbQhgpAAAAAFgQleLafYKy_M6nShmUwm0arwTo',
//   recaptchasiteKey:'6LdbQhgpAAAAADf6eNk9-lcTKI8vUb3pSFU2PFOo',
//   branch_io_secret:'key_live_lAnK3C1BUj4e0N6gPDC52pliyBbA8yDM',
//   maintenanceMode:false,
//   orderInvoiceFolder:'orderinvoicepdf/',
//   magentoS3Path:'https://d1xrk6gpjfttqh.cloudfront.net'  
// };

export const environment = {
  production: false,
  environment: 'staging',
  // apiURL: 'https://api-stg-wos-python.agilecollab.com/',
  apiURL:'https://api-wos-dev2.agilecollab.com/',
  apiVersion: 'v1',
  username: 'appuser@mailinator.com',
  password: 'Admin@123456',
  client_id: 'Qp3IFurNh9hKL9WcwSPTpDaKce1p6bwXrFGvFpjG',
  s3_path: 'https://ds9rxnkva2h7p.cloudfront.net',
  product_image_folder:'thumbnails',
  client_secret: 'bZ3s1CEFYweEaLXiy9CIU7nFYkRwodeLfQ2o5JwqD4DeeL4nwRnbcKahwJhHW4aRGdaiVrHhmbOnrcV2iWPgrwbOA1oamAjlQZ6DFHnVsJRedLR4vkFh9BNckCkQVFeD',
  grant_type: 'password',
  page_size: 10,
  profileFolder:'ordering/profile-images/',
  product_listing_page_size: 15,
  cart_page_size: 20,
  ga:'G-RDJ9TFXYHS',
  domainName:'retailers-stg-wos-python.agilecollab.com',
  versionCheckURL:'https://api-wos-dev2.agilecollab.com/version.json',
  maintenanceMode:false,
  recaptchaSecretKey:'6LeMSRUpAAAAABva_neqgTxHVnR0FEH62QeNZz2l',
  recaptchasiteKey:'6LeMSRUpAAAAAOZJ9UVeVx8JE7tQ5tQniiEh6swY',
  cmsNavigationUrl:'https://retailers-dev2-wos-python.agilecollab.com',
  graphcmsapiurl:'https://api-eu-central-1.graphcms.com/v2/cknrki1wfbcpo01wj1hxy2dmz/stagenvironment',
 qraphapiToken:'eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCIsImtpZCI6ImdjbXMtbWFpbi1wcm9kdWN0aW9uIn0.eyJ2ZXJzaW9uIjozLCJpYXQiOjE2MTk2OTExNDAsImF1ZCI6WyJodHRwczovL2FwaS1ldS1jZW50cmFsLTEuZ3JhcGhjbXMuY29tL3YyL2NrbnJraTF3ZmJjcG8wMXdqMWh4eTJkbXovc3RhZ2Vudmlyb25tZW50IiwiaHR0cHM6Ly9tYW5hZ2VtZW50LW5leHQuZ3JhcGhjbXMuY29tIl0sImlzcyI6Imh0dHBzOi8vbWFuYWdlbWVudC5ncmFwaGNtcy5jb20vIiwic3ViIjoiNDc3MjQ2NjctMGRiMC00ZmY0LTg0MTgtMzMwNzc4MTE0NzkxIiwianRpIjoiY2tvMnFhYW5mejZ3djAxejEzeGhnYXBlaSJ9.KpjmM-f3feMhNZc2Mi40gpiO-wK4Po68cbNpJLn9oHmUmMacnK7BMjwNOeT79F4naQxkjveJ03JNLueKD8XAFC72WkRCMc4yd9HZbiA2XkAEsCPmuDdnoOGLNqnTZUVRM6qwizuJ3AuhWubXSwJhiWXVApkSsND0WXp6lfVvm8p_xjnDMst2PGcVFW7j8EPCR_bJpCtzwsTTr2wIUDrH35FhonMnjvhfTMbCUqYy3C16CAFH3xmYkjZ3Xso4Ag-2sLYh9-I_FX0YNmKgQofMhy1qYoPSVozzymYMaDC8b5YfGNqQ2vzeYwWwnamMW71rIfoYdAtQ61en8w82_mm5svqJUZdhZmo5So6bnJghg7x_FWN_s4HNPanlpATaipKE0wI_bkRIRNllVczwNIO43WUWjTA_2QUOx3_FTQIYbeQZHPcdjV44x9q9gVvr3rBsf6MBqK5XmckT35311Hrw5Do0UuzprqTTulkURNQQXbXjiPjoAGrsz1YUgs_gHVZGd7vqr0LebX77Tzvvlz_TgHmoDnu_nLZuBjwiwKO_ruMvPY_Bf-K85HNzFQKpeOZ-ldkdsEjp1g0eAaVcXflbHdKliT6O11co8BZsHwSuie0SLpz9iKIclMQHslug8qAmvtWJ8P-Z5MImolh7b2K2xtGv3eW9r6_8Y6fmoNBj9a4',
  wos_secret_key:'password@123',
  hashedSecretKey:'f38ecf5379324f565d0365be0547b42e',
  branch_io_secret:'key_test_eCmSWw0sQlYfXQ0oPtB84jgcAqnt6EDZ',
  hashedIV:'186DE986FC69F8E4',
  orderInvoiceFolder:'orderinvoicepdf/',
  magentoS3Path:'https://d1xrk6gpjfttqh.cloudfront.net'
};